import React from "react";
import ReactDOM from "react-dom/client";
import { store } from "./redux/configureStore";
import "./styles/base.scss";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import MainApp from "./App";
import { BrowserRouter } from "react-router-dom";
import { SapaContextProvider } from "./context/Context";
import { initializeAnalytics } from "./utils/analytics";


const root = ReactDOM.createRoot(document.getElementById("root"));

const THEME_CONFIG = {
  hashed: false,
};

initializeAnalytics();

/**<React.StrictMode>**/

root.render(
  <Provider store={store}>
    <ConfigProvider theme={THEME_CONFIG}>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <SapaContextProvider>
          <MainApp />
        </SapaContextProvider>
      </BrowserRouter>
    </ConfigProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
